export const TOKEN_KEY = 'owl_auth_token'
export const REFRESH_TOKEN_KEY = 'owl_refresh_token'
export const USER_INFO_KEY = 'owl_user_info'

export interface TokenData {
  access_token: string
  token_type: string
  expires_at: number
  profile?: any
  currentUser?: any
}

export const tokenService = {
  getToken(): TokenData | null {
    const sessionData = sessionStorage.getItem(TOKEN_KEY)
    const localData = localStorage.getItem(TOKEN_KEY)
    const data = sessionData || localData
    
    if (!data) return null

    const tokenData = JSON.parse(data)
    
    // Retrieve user info if available
    const sessionUserInfo = sessionStorage.getItem(USER_INFO_KEY)
    const localUserInfo = localStorage.getItem(USER_INFO_KEY)
    const userInfoData = sessionUserInfo || localUserInfo
    
    if (userInfoData) {
      tokenData.currentUser = JSON.parse(userInfoData)
    }

    return tokenData
  },

  getAccessToken(): string | null {
    const token = this.getToken()
    if (token && token.expires_at && Date.now() >= token.expires_at) {
      return null // Token expired
    }
    return token?.access_token || null
  },

  getRefreshToken(): string | null {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY) || localStorage.getItem(REFRESH_TOKEN_KEY)
  },

  setTokens(tokenData: any, persistent: boolean = false) {
    const storage = persistent ? localStorage : sessionStorage
    
    // Clear other storage first to avoid confusion
    const otherStorage = persistent ? sessionStorage : localStorage
    otherStorage.removeItem(TOKEN_KEY)
    otherStorage.removeItem(REFRESH_TOKEN_KEY)
    otherStorage.removeItem(USER_INFO_KEY)

    storage.setItem(TOKEN_KEY, JSON.stringify({
      access_token: tokenData.access_token,
      token_type: tokenData.token_type,
      expires_at: tokenData.expires_at,
      profile: tokenData.profile
    }))

    if (tokenData.refresh_token) {
      storage.setItem(REFRESH_TOKEN_KEY, tokenData.refresh_token)
    }

    if (tokenData.currentUser) {
      storage.setItem(USER_INFO_KEY, JSON.stringify(tokenData.currentUser))
    }
  },

  clearTokens() {
    sessionStorage.removeItem(TOKEN_KEY)
    sessionStorage.removeItem(REFRESH_TOKEN_KEY)
    sessionStorage.removeItem(USER_INFO_KEY)
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
    localStorage.removeItem(USER_INFO_KEY)
  }
}
